import React, { Component } from "react";
import {
    Card,
    CardTitle,
    Row,
    Col,
    CardBody
} from "reactstrap";
import { Line } from "react-chartjs-2";
import Registry from "../../../Utils/Registry";
import Utils from "../../../Utils/Helpers";


class AnalyticsChartConsumption extends Component{
    constructor(props){
        super(props);

        this.loadData = this.loadData.bind(this);
        this.setPeriodView = this.setPeriodView.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            view: "month",

            big_data: {
                gas: {},
                labels: [],
                keys: []
            }
        };
    }

    setPeriodView(view){
        this.setState({view: view});
        this.loadData(view);
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(view=false){
        if(!view)
            view = this.state.view;

        let keys = {};
        let datesKey = [];
        let labels = [];
        let new_date = false;

        this.api.get("/stats/customers?nb_period=12&is_business=1&period="+view)
            .then(results => {
                console.log(results);

                for(let d of results.data){
                    let k = (view === "week" ? d.week : "")+(view === "month" ? d.month : "")+d.year;

                    if(keys[d.gas_shorten] === undefined){
                        keys[d.gas_shorten] = {
                            name: d.gas_name,
                            shorten: d.gas_shorten,
                            unit: d.gas_unit,
                            color: d.gas_color,
                            full: 0,
                            data: {}
                        }
                    }

                    if(datesKey.indexOf(k) === -1){
                        datesKey.push(k);

                        if(view === "week")
                            new_date = "S" + d.week;
                        else if(view === "month")
                            new_date = d.month + "/" + d.year;
                        else
                            new_date = d.year;

                        labels.push(new_date);
                    }

                    let tot = parseFloat(d.total_quantity_delivered);
                    keys[d.gas_shorten].data[k] = tot;
                    keys[d.gas_shorten].full += tot;
                }

                this.setState({
                    big_data: {
                        gas: keys,
                        labels: labels,
                        keys: datesKey
                    }
                });
            });
    }

    _getDataArray = () => {
        let dataSets = [];

        for(let d of Object.values(this.state.big_data.gas)){
            let data = [];
            for(let k of this.state.big_data.keys){
                if(d.data.hasOwnProperty(k))
                    data.push(d.data[k]);
                else
                    data.push(0);
            }

            dataSets.push({
                label: d.name,
                fill: false,
                borderColor: d.color,
                data: data
            });
        }

        return dataSets;
    }

    render(){
        return (
            <div className="">

                <Card className="">
                    <CardBody className="card-body pb-0">
                        <Row>
                            <Col xs="7" sm="7" lg="6" className="pad-xs-r-0">
                                <CardTitle className="mb-0 ty-subtitle">
                                    Carburant
                                </CardTitle>

                                <div className="ty-period-filters">
                                    <span className={this.state.view == "week" ? "blue" : "pointer"} onClick={() => {this.setPeriodView("week")}}>Semaine</span> |
                                    <span className={this.state.view == "month" ? "blue" : "pointer"} onClick={() => {this.setPeriodView("month")}}> Mois</span> |
                                    <span className={this.state.view == "year" ? "blue" : "pointer"} onClick={() => {this.setPeriodView("year")}}> Ann&eacute;e</span>
                                </div>
                            </Col>
                            <Col xs="5" sm="5" lg="6" className="pad-xs-l-0">
                                <table className="float-right ty-legend-size">
                                    <tbody>
                                        {
                                            Object.values(this.state.big_data.gas).map((g, i) => {
                                                if(!g.full)
                                                    return null;
                                                return <tr key={"g-budget-"+ i}>
                                                    <td><span className="pad-r-10" style={{color: g.color}}>{g.name}</span></td>
                                                    <td>{g.full.toFixed(2)}{Utils.isMobile() ? '' : ' '}{g.unit}</td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className="marg-t-20">
                            <Col md="12">
                                <div className="chart-wrapper marg-b-20">
                                    <Line 
                                        data={{
                                            labels: this.state.big_data.labels,
                                            datasets: this._getDataArray()
                                        }} 
                                        options={this.props.options} 
                                        height={Utils.isMobile() ? "200rem" : null}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

            </div>
        );
    }
}

AnalyticsChartConsumption.defaultProps = {
    options: {
        legend: {
            display: false
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    }
};


export default AnalyticsChartConsumption;



// WEBPACK FOOTER //
// ./src/components/Analytics/Charts/Consumption.js